import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "./api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchMe = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    if (localStorage.getItem("tara_token")) fetchMe();
    else setLoading(false);
  }, [fetchMe]);

  // Heartbeat every 60s
  useEffect(() => {
    if (!user) return;
    const t = setInterval(() => {
      api.post("/presence/heartbeat").catch(() => {});
    }, 60000);
    // initial mark online
    api.post("/presence", { presence: "online" }).catch(() => {});
    return () => clearInterval(t);
  }, [user]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    if (data.requires_2fa || data.requires_setup) {
      // Caller (Login page) handles multi-step flow; return raw data
      return data;
    }
    localStorage.setItem("tara_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const finalizeSession = (data) => {
    if (data?.token) {
      localStorage.setItem("tara_token", data.token);
      setUser(data.user);
    }
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch {}
    localStorage.removeItem("tara_token");
    setUser(null);
  };

  const setPresence = async (presence) => {
    await api.post("/presence", { presence });
    setUser((u) => (u ? { ...u, presence } : u));
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, finalizeSession, logout, setPresence, refresh: fetchMe }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
